import ImagePlaceholder from "@/components/base/ImagePlaceholder";

export default function Intervention() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="relative rounded-2xl overflow-hidden">
            <ImagePlaceholder src="https://readdy.ai/api/search-image?query=Professional%20technician%20replacing%20a%20white%20roller%20shutter%20remote%20control%20and%20programming%20a%20new%20one%20with%20a%20Somfy%20remote%20in%20a%20modern%20French%20home%20interior%20clean%20bright%20lighting%20professional%20service%20photography%20warm%20neutral%20tones&width=700&height=520&seq=tele-int&orientation=landscape" alt="Technicien remplaçant une télécommande de volet roulant à Strasbourg" className="w-full h-[340px] md:h-[420px]" loading="lazy" />
          </div>

          <div>
            <h2 className="text-[#1B2A4A] text-2xl md:text-3xl font-extrabold mb-5">
              En quoi consiste l&apos;intervention
            </h2>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-5">
              Le remplacement d&apos;une télécommande ou d&apos;un point de commande de volet roulant commence par un diagnostic du système de commande. Nos techniciens vérifient que le problème vient bien de la télécommande ou du bouton mural et non du moteur ou du récepteur. Nous testons la portée de la télécommande, la réponse du récepteur radio et l&apos;état du câblage du point de commande mural.
            </p>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-5">
              Nous remplaçons la télécommande défectueuse par une télécommande compatible avec votre motorisation Somfy, Nice ou Simu. Nous reprogrammons la nouvelle télécommande avec votre moteur et configurons les canaux si nécessaire. Pour les points de commande muraux, nous remplaçons le bouton ou le boîtier et vérifions le câblage jusqu&apos;au récepteur.
            </p>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-8">
              Enfin, nous testons le bon fonctionnement de l&apos;ensemble : montée, descente, arrêt intermédiaire et programmation des positions favorites. Nous vérifions la portée de la télécommande et la réactivité du point de commande mural. L&apos;intervention dure généralement moins d&apos;une heure. Nous proposons des télécommandes et points de commande de qualité avec garantie.
            </p>

            <a
              href="tel:0374473240"
              className="flex items-center gap-2 bg-[#E8734A] text-white px-6 py-4 rounded-full font-semibold text-base hover:bg-[#E8734A]/90 transition-colors whitespace-nowrap mx-auto"
            >
              <i className="ri-phone-line text-lg"></i>
              Appeler le 03 74 47 32 40
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}